import { render, staticRenderFns } from "./ConnectXero.vue?vue&type=template&id=229734ce&"
import script from "./ConnectXero.vue?vue&type=script&lang=js&"
export * from "./ConnectXero.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports